import { useState } from "react";
import { Phone } from "lucide-react";
import EstimateFlow from "./EstimateFlow";
import StickyMobileBar from "./StickyMobileBar";

export const PHONE = "617-717-9852";
export const PHONE_HREF = "tel:+16177179852";

export default function SeoPageShell({ children, testid }) {
  const [flowOpen, setFlowOpen] = useState(false);
  const onStart = () => setFlowOpen(true);

  return (
    <div className="App grain min-h-screen bg-canvas" data-testid={testid}>
      <header className="px-5 pt-5 sm:px-8">
        <div className="mx-auto flex max-w-7xl items-center justify-between rounded-full bg-white/80 px-6 py-3.5 ring-1 ring-charcoal/5 backdrop-blur">
          <a href="/" data-testid="seo-logo-link" className="font-logo font-semibold text-3xl lowercase text-violet">milla</a>
          <div className="flex items-center gap-4">
            <a href={PHONE_HREF} data-testid="seo-phone-link" className="hidden items-center gap-2 text-sm font-semibold text-charcoal sm:inline-flex">
              <Phone size={16} className="text-violet" /> {PHONE}
            </a>
            <button onClick={onStart} data-testid="seo-header-cta" className="rounded-full bg-violet px-6 py-2.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-violet-deep">
              Get an instant quote
            </button>
          </div>
        </div>
      </header>

      {children(onStart)}

      <footer className="px-5 pb-8 sm:px-8">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 border-t border-charcoal/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-charcoal/45">© {new Date().getFullYear()} milla. Get your space back.</p>
          <a href={PHONE_HREF} className="text-sm text-charcoal/60 hover:text-violet">Call {PHONE}</a>
        </div>
      </footer>

      <StickyMobileBar onStart={onStart} hidden={flowOpen} />
      <EstimateFlow open={flowOpen} onClose={() => setFlowOpen(false)} />
    </div>
  );
}
